import React, { useEffect } from "react";

const DropDownInput = ({
  id,
  options,
  title,
  className = "",
  onChange = "",
  onChangeFunction,
  value: defaultValue = "",
  preValue,
  onFormChange,
  disabled = false,
  dependentElem,
  showDependentOn = "",
  style = { fontSize: "10px" },
  name,
  size = "lg",
}) => {
  if (preValue) defaultValue = preValue;
  //called after render only once
  useEffect(() => {
    internalOnChange(null, false);
  }, []);

  const showHideDependentElement = (element) => {
    const select = document.getElementById(id);
    if (select.value === showDependentOn) {
      element.classList.remove("d-none");
      element.required = true;
    } else {
      element.classList.add("d-none");
      element.required = null;
    }
  };

  const internalOnChange = (e, checkForm = true) => {
    if (checkForm && onFormChange) onFormChange(e);

    if (dependentElem) {
      const dependentElement = document.getElementById(dependentElem);
      dependentElement && showHideDependentElement(dependentElement);
    }

    if (onChange && window[onChange]) {
      window[onChange](e);
    }

    if (onChangeFunction) {
      onChangeFunction(e);
    }
  };

  return (
    <select
      disabled={disabled}
      defaultValue={defaultValue}
      className={`form-control ${
        size === "sm" ? "form-control-sm" : ""
      } ${className}`}
      id={id}
      onChange={internalOnChange}
      style={style}
      name={name}
    >
      {options.map((option, index) => {
        return (
          <option
            key={index}
            value={typeof option === "object" ? option?._id : option}
          >
            {typeof option === "object"
              ? option?.name ||
                option?.label ||
                option?.title ||
                option?.county ||
                ""
              : option}
          </option>
        );
      })}
    </select>
  );
};

export default DropDownInput;
